import React, { Component } from 'react'
import Slider from 'react-slick'

export default class NeighbordSlider extends Component {

  constructor(props) {
    super(props)
    this.changeHandler = this.changeHandler.bind(this)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }

  changeHandler(val) {
    this.refs.slider.slickGoTo(val)
  }

  next() {
  this.refs.slider2.slickNext()
  }
  previous() {
    this.refs.slider2.slickPrev()
  }

  shouldComponentUpdate (nextProps, nextState){
    if (this.props.gallery.length !== nextProps.gallery.length){
      return true
    }
    return false
  }

  render() {

    const settings = {
      className: "top-slide",
      dots: true,
      autoplay: true,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true
    };

    const settings2 = {
      className: "bottom-slide hidden-xs",
      dots: false,
      autoplay:false,
      infinite: true,
      speed: 400,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      lazyLoad: true
    };

    const { gallery } = this.props

    return (
      <div>
        <Slider ref='slider' {...settings}>
          {gallery.map((item, index) =>
            <div key={index}>
              <img src={item} />
            </div>
          )}
        </Slider>
        <Slider ref='slider2' {...settings2}>
          {gallery.map((item, index) =>
            <div key={index}>
              <a onClick={() => this.changeHandler(index)}>
                <img src={item} />
              </a>
            </div>
          )}
        </Slider>
        <div className="slider-buttons hidden-xs">
            <div className="left-buttons">
              <button className='button' onClick={this.previous}>
                <i className="fa fa-angle-left fa-3x" aria-hidden="true"></i>
              </button>
            </div>
            <div className="right-buttons">
              <button className='button' onClick={this.next}>
                <i className="fa fa-angle-right fa-3x" aria-hidden="true"></i>
              </button>
            </div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/components/Slide/index.js